import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, FormControlLabel, Switch } from '@material-ui/core';
import PublicPage from '../PublicPage';
import Typo from '../../components/CustomTypo';
import { portalCfg } from '../../../portal.router.config';
import Button from '../../components/ButtonCustom';
import { LinkRouter } from '../../components/Link';
import { Field, Form } from 'react-final-form';
import { TextFieldComponent, TextFieldWithSelectComponent } from '../../components/FormElement';
import validators from '../../utils/validators';
import SocialComponent from '../../components/SocialComponent'
import { InformPasswordIcon, RadioCheckedIcon, RadioIcon, SwichGreenActiveIcon, SwichIcon } from '../../components/icons'
import countries from '../../../countries';
import { domainName } from '../../../portal.config';
import { CheckBoxOutlineBlank, CheckBoxOutlined, CheckOutlined } from '@material-ui/icons';
import { getAppCfg } from '../../utils/common';
import TermAndConditionsView from '../more-info/TermAndConditionsView';
import PrivacyPolicyView from '../more-info/PrivacyPolicyView';

const lang_icon_en = portalCfg.publicPath + "/icons/usa_flag.png";
const MIN_LENGTH_PASSWORD = 8;

const styles = theme => ({
    container: {
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(10),
        [theme.breakpoints.down('sm')]: {
            paddingBottom: theme.spacing(2),
        },
    },
    marginTop: {
        marginTop: theme.spacing(2),
    },
    marginTop2x: {
        marginTop: theme.spacing(10),
    },
    marginTop4x: {
        marginTop: theme.spacing(20),
    },
    formLogin: {
        marginTop: theme.spacing(4),
        backgroundColor: theme.palette.background.box,//'#ffffff1f',
        borderRadius: 10,
        padding: theme.spacing(5, 15, 10, 15),
    },
    form_select: {
        marginTop: theme.spacing(4),
        cursor: 'pointer'
    },
    swichSmall: {
        marginTop: theme.spacing(2),
        resizeMode: 'contain',
        cursor: 'pointer'
    },
    inform: {
        cursor: 'pointer',
    },
    inform_password: {
        position: 'relative',
    },
    inform_password_desc: {
        padding: theme.spacing(3),
        backgroundColor: theme.palette.background.secondary,
        // marginTop: theme.spacing(3),
        borderRadius: theme.spacing(3),
        border: '1px solid ' + theme.palette.border.secondary,
        position: 'absolute',
        zIndex: 10,
    },
    link: {
        color: theme.palette.text.secondary,
    }
});

function RegisterExistingView(props) {
    const { classes, t, showAlert, onShowLoading, register_info, showFormCredential, customer } = props;
    const [showInform, setShowInform] = useState(false);
    const [openTermCondition, setOpenTermCondition] = useState(false);
    const [openPrivacyPolicy, setOpenPrivacyPolicy] = useState(false);

    console.log("customer==", customer);
    let isAllowAddCredential = showFormCredential ? props.isAcceptTerm : true;

    const app_config = getAppCfg();
    const about_details = app_config && app_config.about_details ? app_config && app_config.about_details : {}

    const onClickTermCondition = () => {
        let url = about_details.terms_conditions && about_details.terms_conditions.url ? about_details.terms_conditions.url : null;
        if (url) {
            window.open(url, "_blank");
        } else {
            setOpenTermCondition(true)
        }
    }

    const onClickPrivacyPolicy = () => {
        let url = about_details.privacy_policy && about_details.privacy_policy.url ? about_details.privacy_policy.url : null;
        if (url) {
            window.open(url, "_blank");
        } else {
            setOpenPrivacyPolicy(true)
        }
    }

    return (
        <PublicPage
            rightComponent={
                <Grid xs={12} sm={12} md={12} item container>
                    <Grid xs={12} sm={12} item container>
                        <Typo variant='h3' color={domainName == 'buyway' ? 'onPrimary' : 'primary'} mg_bottom_md>{t('register_existing_title')}</Typo>
                    </Grid>
                    <Grid xs={12} item container direction="row">
                        <Typo variant='body2' color={domainName == 'buyway' ? 'onPrimary' : 'primary'} center>{t('already_account')}&nbsp;</Typo>
                        <LinkRouter to='login' variant='body2' size='sm' color='primary'>{t('btn_login')}</LinkRouter>
                    </Grid>
                    <Grid xs={12} sm={12} item container justify='center'>
                        <Form
                            onSubmit={props.onSubmit}
                            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                <Grid xs={12} container item>
                                    <Field
                                        name="email"
                                        component={TextFieldComponent}
                                        label={t('email')}
                                        placeholder={t('email_input_placeholder')}
                                        isEdit={true}
                                        color='default'
                                        validate={validators.composeValidators(validators.validEmail)}
                                        autoFocus={true}
                                        defaultValue={customer && customer.email_address ? customer.email_address : null}
                                    />
                                    {showFormCredential && <>
                                        <Field
                                            name="password"
                                            component={TextFieldComponent}
                                            customLabel={true}
                                            label={<Grid item xs={12} container className={classes.inform} onMouseEnter={() => setShowInform(true)} onMouseLeave={() => setShowInform(false)}>
                                                <Typo mg_left_md variant="input_label" color="default">{t('password')}</Typo>
                                                <Grid item style={{ marginLeft: 10 }}><InformPasswordIcon /></Grid>
                                            </Grid>}
                                            placeholder={t('enter_your_password')}
                                            isEdit={true}
                                            color='default'
                                            validate={validators.composeValidators(validators.required, validators.validMinLength(MIN_LENGTH_PASSWORD))}
                                            autoFocus={true}
                                            type='password'
                                        />
                                        {showInform && <Grid item xs={12} className={classes.inform_password}>
                                            <Grid item className={classes.inform_password_desc}>
                                                <Typo color='error'>{t('inform_password')}</Typo>
                                                <Typo color='error'>{t('inform_password_1')}</Typo>
                                                <Typo color='error'>{t('inform_password_2')}</Typo>
                                                <Typo color='error'>{t('inform_password_3')}</Typo>
                                                <Typo color='error'>{t('inform_password_4')}</Typo>
                                                {/* <Typo color='error'>{t('inform_password_5')}</Typo> */}
                                            </Grid>
                                        </Grid>}
                                        <Field
                                            name="confirm_password"
                                            component={TextFieldComponent}
                                            label={t('confirm_password')}
                                            placeholder={t('confirm_password_placeholder')}
                                            isEdit={true}
                                            color='default'
                                            autoFocus={true}
                                            type='password'
                                            validate={validators.composeValidators(validators.validNotMatch({ compareValue: values.password, message: t('enter_same_password') }, values.confirm_password))}
                                        />
                                        <Grid item xs={12} container className={classes.marginTop2x} style={{ cursor: 'pointer', alignItems: 'center' }} onClick={() => props.setIsAcceptTerm(!props.isAcceptTerm)}>
                                            {props.isAcceptTerm ? <CheckBoxOutlined fontSize='medium' /> : <CheckBoxOutlineBlank fontSize='medium' />}
                                            <Typo mg_left_sm>I agree with the <a onClick={() => onClickTermCondition()} className={classes.link}>Terms & Conditions</a> and <a onClick={() => onClickPrivacyPolicy()} className={classes.link}>Privacy Policy</a></Typo>
                                        </Grid>
                                    </>
                                    }
                                    <Grid xs={12} item container justify='center' className={classes.marginTop2x}>
                                        <Button color='primary' fullWidth onClick={handleSubmit} disabled={!isAllowAddCredential}>{!showFormCredential ? t('btn_send_opt') : t('Add Credential')}</Button>
                                    </Grid>
                                </Grid>
                            )} />
                    </Grid>
                    {openTermCondition && <TermAndConditionsView
                        open={openTermCondition}
                        onCloseItem={() => setOpenTermCondition(false)}
                        about_details={about_details}
                    />}
                    {openPrivacyPolicy && <PrivacyPolicyView
                        open={openPrivacyPolicy}
                        onCloseItem={() => setOpenPrivacyPolicy(false)}
                        about_details={about_details}
                    />}
                </Grid>}
        />
    );
}
export default withStyles(styles)(withTranslation()(RegisterExistingView));